module.exports = __webpack_public_path__ + "img/search-oliver2.143f622c.png";